"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * The type of operating system (OS) or web browser that the user uses, or similar computer or device information.
 */
exports.DeviceSubCategory = (0, type_utils_1.makeEnum)({
    /** A unique device identifier */
    SerialNumber: 'SERIAL_NUMBER',
    /** Fallback subcategory */
    Device: 'DEVICE',
});
//# sourceMappingURL=device.js.map